import type { FlowDefinition } from "../api/flows";
import { summarize } from "./flowEditor";
import { t } from "../i18n";

/** Where a flow handed the conversation back starts: its beginning, where it stopped, or a step. */
export type StartFrom = "beginning" | "resume" | "step";

/** Where the flow stopped when a person took the conversation over. */
export interface StoppedFlow {
  flowId: string;
  nodeId: string;
}

/** The steps a flow can start from, by what they do and say ("Menu · Como posso ajudar?"). */
export function flowSteps(
  def: FlowDefinition | null,
): Array<{ id: string; label: string }> {
  if (!def) return [];
  return def.nodes
    .filter((n) => n.kind !== "start")
    .map((n) => {
      const said = summarize(n).replace(/\s+/g, " ").trim();
      const what = t(("node." + n.kind) as never);
      return {
        id: n.id,
        label: said
          ? `${what} · ${said.length > 48 ? `${said.slice(0, 47)}…` : said}`
          : `${what} · ${n.id}`,
      };
    });
}

/** The ways to start the chosen flow: "where it stopped" only when it stopped there in this chat. */
export function startChoices(
  flowId: string | undefined,
  stopped: StoppedFlow | null,
  def: FlowDefinition | null,
): StartFrom[] {
  const resumable =
    !!flowId &&
    stopped?.flowId === flowId &&
    !!def?.nodes.some((n) => n.id === stopped.nodeId);
  return resumable ? ["resume", "beginning", "step"] : ["beginning", "step"];
}
